var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bell",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 24.316,
    viewBox: "0 0 20 24.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    width: 20,
    height: 24.316,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2716",
    "data-name": "Group 2716",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M10,24.3H9.927A3.2,3.2,0,0,1,6.8,21.031l1.7.035a1.5,1.5,0,1,0,2.992.062V21.12c0-.014,0-.029,0-.044l1.7-.053c0,.048,0,.1,0,.144A3.2,3.2,0,0,1,10,24.3Z",
    transform: "translate(0.006 0.02)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M18.313,20.456H1.686A1.686,1.686,0,0,1,.162,18.048,14.525,14.525,0,0,0,1.7,12.569V8.675A8.5,8.5,0,0,1,9.978,0h.042A8.5,8.5,0,0,1,18.3,8.679v3.894a14.533,14.533,0,0,0,1.541,5.475,1.685,1.685,0,0,1-1.523,2.408Zm-16.6-1.7H18.288a15.756,15.756,0,0,1-1.694-6.182V8.649A6.793,6.793,0,0,0,10,1.7,6.8,6.8,0,0,0,3.406,8.645v3.924A15.747,15.747,0,0,1,1.711,18.755Z",
    transform: "translate(0 0)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.1c4028643d2e717253143fe4d572b958.svg";
export { ForwardRef as ReactComponent };